import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const AreaChart = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 17C4.09722 17 3.74653 16.8507 3.44792 16.5521C3.14931 16.2535 3 15.9028 3 15.5V4.5C3 4.0875 3.14931 3.73438 3.44792 3.44063C3.74653 3.14688 4.09722 3 4.5 3H15.5C15.9125 3 16.2656 3.14688 16.5594 3.44063C16.8531 3.73438 17 4.0875 17 4.5V15.5C17 15.9028 16.8531 16.2535 16.5594 16.5521C16.2656 16.8507 15.9125 17 15.5 17H4.5ZM4.5 13.7708V15.5H15.5V7.625L10.0208 13.2917L7.5 10.7708L4.5 13.7708ZM4.5 11.6667L7.5 8.66667L10 11.1458L15.5 5.47917V4.5H4.5V11.6667ZM4.5 8.58333V6.3125V11.6667V8.54167V13.7708V8.58333ZM4.5 13.7708V8.58333V15.5V13.7708Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  )
}

AreaChart.muiName = SvgIcon.muiName
export default AreaChart
